import { HttpApiSecurity as service } from 'app/http';
import {
  type LoginWith2faModel,
  type LoginWith2faResponse,
  type LoginWithRecoveryCodeModel,
  type LoginWithRecoveryResponse
} from 'app/modules/Security/models/loginWith2fa.model';
import env from 'env';
import UrlUtils from 'utils/url-utils';

import {
  type LoginExternalWsRequest,
  type LoginExternalWsResponse,
  type LoginRequest,
  type LoginResponse,
  type LoginUserNameRequest,
  type LoginUserNameResponse
} from '../../modules/Security/models/login.model';

import { type AuthContext } from './types';

const baseUrl = '/v1/account';

class FormularioService {
  login(login: LoginRequest): Promise<LoginResponse> | Promise<any> {
    const bodyFormData = new FormData();
    bodyFormData.append('username', login.username);
    bodyFormData.append('password', login.password);
    // puede suceder que returnUrl sea nulo
    bodyFormData.append(
      'returnUrl',
      login.returnUrl ?? UrlUtils.urlConcat(env.appUrl, '').toString()
    );
    bodyFormData.append('rememberLogin', login.rememberLogin ? 'true' : 'false');
    bodyFormData.append('DNTCaptchaInputText', login.DNTCaptchaInputText as string);
    bodyFormData.append('DNTCaptchaText', login.DNTCaptchaText as string);
    bodyFormData.append('DNTCaptchaToken', login.DNTCaptchaToken as string);

    return service
      .postCfg<LoginResponse>(`${baseUrl}/login`, bodyFormData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  loginExternalWs(login: LoginExternalWsRequest): Promise<LoginExternalWsResponse> | Promise<any> {
    const bodyFormData = new FormData();

    bodyFormData.append('username', login.username);
    bodyFormData.append('password', login.password);
    bodyFormData.append('validateCaptcha', login.DNTCaptchaToken ? 'true' : 'false');
    bodyFormData.append('returnUrl', login.returnUrl);
    bodyFormData.append('DNTCaptchaInputText', login.DNTCaptchaInputText as string);
    bodyFormData.append('DNTCaptchaText', login.DNTCaptchaText as string);
    bodyFormData.append('DNTCaptchaToken', login.DNTCaptchaToken as string);

    return service
      .postCfg<LoginResponse>(`${baseUrl}/loginexternalws`, bodyFormData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  loginUserName(login: LoginUserNameRequest): Promise<LoginUserNameResponse> | Promise<any> {
    return service
      .post<LoginResponse>(`${baseUrl}/loginusername`, login)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  loginWith2fa(model: LoginWith2faModel): Promise<LoginWith2faResponse> | Promise<any> {
    return service
      .post<LoginWith2faResponse>(`${baseUrl}/loginwith2fa`, model)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  loginWithRecoveryCode(
    model: LoginWithRecoveryCodeModel
  ): Promise<LoginWithRecoveryResponse> | Promise<any> {
    return service
      .post<LoginWithRecoveryResponse>(`${baseUrl}/loginwithrecoverycode`, model)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  getContext(): Promise<AuthContext> {
    return service.get(`${baseUrl}/authcontext`, { headers: { lang: true } });
  }

  get(url: string): Promise<any> {
    return service.get<any>(url);
  }
}
export default new FormularioService();
